module.exports = __webpack_public_path__ + "images/1.1788921444950.jpg";